'use client';

import { ExitBreakPlugin } from '@udecode/plate-break/react';


export const exitBreakPlugin = ExitBreakPlugin.configure({
  options: {
    rules: [
      {
        hotkey: 'mod+enter',
      },
      {
        before: true,
        hotkey: 'mod+shift+enter',
      },
      {
        hotkey: 'enter',
        query: {
          allow: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
          end: true,
        },
      },
    ],
  },
});
